import objectPrefix from '../lib/objectPrefix';

const prefix = objectPrefix();

const tiles = require('./general/tiles');

module.exports = _.extend(
    require('./partials/slotMachine'),
    require('./partials/dadPump'),
    require('./partials/blobsTreadmill'),
    require('./partials/puppetMasters'),
    require('./partials/trioFunnel'),
    require('./partials/treadmill'),
    require('./partials/bucketGuards'),
    require('./partials/vacuum'),
    require('./partials/blob'),
    require('./partials/endFrame'),
    require('./general/tiles'),
    // require('./general/faces'),
    {
        buttonBg: {
            texture: '/img/scenes/oligarchie/hand-press-button/button-bg.jpg',
            position: {
                x: '0%',
                y: '0%',
            },
            scale: {
                x: '100%',
            },
        },

        handPressButton: {
            type: 'movieclip',
            frames: {
                '1': {
                    position: {
                        x: '50%',
                        y: '0%',
                    },
                    scale: {
                        x: '50%',
                    },
                },
                '2': {
                    position: {
                        x: '60%',
                        y: '0%',
                    },
                    scale: {
                        x: '40%',
                    },
                },
                '3': {
                    position: {
                        x: '60%',
                        y: '0%',
                    },
                    scale: {
                        x: '40%',
                    },
                },
                '4': {
                    position: {
                        x: '0%',
                        y: '0%',
                    },
                    scale: {
                        x: '100%',
                    },
                },
                '5': {
                    position: {
                        x: '0%',
                        y: '69%',
                    },
                    scale: {
                        x: '100%',
                    },
                },
                '6': {
                    position: {
                        x: '55%',
                        y: '0%',
                    },
                    scale: {
                        x: '45%',
                    },
                },
            },
            texture: `sprite:/img/partials/hand-press-button/hand-press-button-${prefix}.json,hand-press-button/`,
        },

        //---------------------------------------------------------------------------------------

        pipesTitle: {
            texture: '/img/scenes/oligarchie/pipes.png',
            scale: {
                x: '100%',
            },
        },

        oligarchieTitle: {
            texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/oligarchie-title.png',
        },

        oligarchieTitleFr: {
            texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/oligarchie-title-fr.png',
        },
    },
);



// WEBPACK FOOTER //
// ./js/objects/oligarchie.js